import { Card } from "antd"
import styles from "./CardKesan.module.css"

const CardKesan = (props) => {

  const {tittle, topic, date, kesan, profile, nama, detail} = props;
  return (
    <>
      <Card variant="borderless" className={styles.cardKesan}>
        <div className={styles.contentWrap}>
          <div className={styles.headerCard}>
            <h4 className={styles.tittle}>{tittle}</h4>
            <p className={styles.topic}>{topic}</p>
            <p className={styles.date}>{date}</p>
          </div>
          <p className={styles.kesan}>“{kesan}”</p>
        </div>
        <div className={styles.footerCard}>
          <div>
            <img src={profile} alt="" className={styles.avatar} />
          </div>
          <div>
            <h3 className={styles.nama}>{nama}</h3>
            <h5 className={styles.detail}>{detail}</h5>
          </div>
        </div>
      </Card>
    </>
  )
}
export default CardKesan
